export enum BrandingVariant {
  COLORFUL = 'colorful',
  WHITE = 'white'
}

export enum BrandingSize {
  FULL = 'full',
  ICON = 'icon'
}